export default __webpack_public_path__ + "static/media/404.0fd430f0.png";